import { render } from "./TheButtonInDropdown.vue?vue&type=template&id=12768d89"
import script from "./TheButtonInDropdown.vue?vue&type=script&lang=js"
export * from "./TheButtonInDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__